/**
 * Módulo: Assistência Técnica - Lista por Estado e CEP
 */
export default function initAssistenciaLista() {
    const cepInput = document.getElementById('cep-input');
    const stateButtons = document.querySelectorAll('.js-state-btn');
    const resultsContainer = document.getElementById('js-assistencia-results');
    const paginationContainer = document.getElementById('js-pagination');
    const stateList = document.querySelector('.c-state-nav__list');

    if (!resultsContainer) return;

    let estadoAtual = '';
    let paginaAtual = 1;
    let isDown = false;
    let startY;
    let scrollTop;

    if (stateList) {
        stateList.addEventListener('mousedown', (e) => {
            isDown = true;
            stateList.style.cursor = 'grabbing';
            startY = e.pageY - stateList.offsetTop;
            scrollTop = stateList.scrollTop;
        });

        stateList.addEventListener('mouseleave', () => {
            isDown = false;
            stateList.style.cursor = 'grab';
        });

        stateList.addEventListener('mouseup', () => {
            isDown = false;
            stateList.style.cursor = 'grab';
        });

        stateList.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const y = e.pageY - stateList.offsetTop;
            const walk = (y - startY) * 2;
            stateList.scrollTop = scrollTop - walk;
        });
    }

    /**
     * Máscara e gatilho de busca do CEP
     */
    if (cepInput) {
        cepInput.addEventListener('input', (event) => {
            let value = event.target.value.replace(/\D/g, ''); // Remove não números

            // Aplica a máscara 00000-000
            if (value.length > 5) {
                value = value.replace(/^(\d{5})(\d)/, '$1-$2');
            }
            event.target.value = value;

            // Dispara a busca automaticamente ao completar 9 caracteres
            if (value.length === 9) {
                buscarEstadoPorCep(value);
            }
        });
    }

    /**
     * Consulta API pública ViaCEP
     * @param {string} cep 
     */
    async function buscarEstadoPorCep(cep) {
        const cleanCep = cep.replace(/\D/g, '');
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
            if (!response.ok) throw new Error('Erro ViaCEP');

            const data = await response.json();

            if (data.uf) {
                // ViaCEP retorna UF em maiúsculo. WP usa slugs minúsculos.
                const ufMinusculo = data.uf.toLowerCase();
                const ufMaiusculo = data.uf.toUpperCase();

                // Tenta buscar o botão pelo data-state (tanto maiúsculo quanto minúsculo)
                const btnAlvo = document.querySelector(`.js-state-btn[data-state="${ufMinusculo}"]`) ||
                    document.querySelector(`.js-state-btn[data-state="${ufMaiusculo}"]`);

                if (btnAlvo) {
                    btnAlvo.click(); // Clica no botão do estado

                    // UX Extra: Faz um scroll suave até a área de resultados para o usuário ver que filtrou
                } else {
                    console.warn(`Estado ${data.uf} retornado pelo CEP não possui um botão correspondente na interface.`);
                }
            } else if (data.erro) {
                console.warn('CEP não encontrado pelo ViaCEP.');
            }
        } catch (error) {
            console.error('Falha ao buscar CEP', error);
        }
    }

    /**
     * Gerencia o clique nas abas de Estado
     */
    stateButtons.forEach(btn => {
        btn.addEventListener('click', (event) => {
            stateButtons.forEach(b => b.classList.remove('--is-active'));
            const alvo = event.currentTarget;
            alvo.classList.add('--is-active');

            estadoAtual = alvo.dataset.state;
            paginaAtual = 1;
            buscarAssistencias();
        });
    });

    const primeiroEstado = document.querySelector('.js-state-btn');
    if (primeiroEstado) {
        primeiroEstado.click();
    }

    /**
     * Busca os dados na REST API do WordPress
     */
    async function buscarAssistencias() {
        // Estado de loading
        resultsContainer.innerHTML = '<p class="c-assistencia-grid__loading">Buscando assistências...</p>';
        paginationContainer.classList.add('--is-hidden');
        paginationContainer.innerHTML = '';

        try {
            // Constrói os parâmetros. Ajuste 'per_page' conforme a necessidade do design.
            const params = new URLSearchParams({
                estado: estadoAtual,
                page: paginaAtual,
                per_page: 3
            });

            const response = await fetch(`/wp-json/pdr/v1/assistencias?${params.toString()}`);
            if (!response.ok) throw new Error('Erro na API WP');

            const data = await response.json();

            // Captura o total de páginas retornado pelo WordPress nos headers
            const totalPaginas = parseInt(response.headers.get('X-WP-TotalPages'), 10) || 1;

            renderizarCards(data);
            renderizarPaginacao(totalPaginas);

        } catch (error) {
            console.error(error);
            resultsContainer.innerHTML = '<p class="c-assistencia-grid__error">Ocorreu um erro ao buscar os dados. Tente novamente.</p>';
        }
    }

    /**
     * Constrói e injeta o HTML dos cards no DOM
     * @param {Array} dados 
     */
    function renderizarCards(dados) {
        if (!dados || dados.length === 0) {
            resultsContainer.innerHTML = '<p class="c-assistencia-grid__empty">Nenhuma assistência encontrada.</p>';
            return;
        }

        const cardsHTML = dados.map(item => {
            const telefonesHTML = item.telefone && item.telefone.length > 0
                ? item.telefone.map(tel => {
                    const telLink = tel.replace(/[^\d+]/g, '');
                    return `
                    <div class="c-card-assistencia__item c-card-assistencia__item--tel">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFB800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                        <a href="tel:${telLink}">${tel}</a>
                    </div>`;
                }).join('')
                : '';

            const emailsHTML = item.email && item.email.length > 0
                ? item.email.map(mail => `
                    <div class="c-card-assistencia__item c-card-assistencia__item--email">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#FFB800" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                        <a href="mailto:${mail}">${mail}</a>
                    </div>`).join('')
                : '';

            const mapsLink = (item.lat && item.lng)
                ? `https://www.google.com/maps/dir/?api=1&destination=$${item.lat},${item.lng}`
                : `https://maps.google.com/?q=${encodeURIComponent(item.logradouro + ', ' + item.numero + ' - ' + item.cidade)}`;

            return `
                <article class="c-card-assistencia">
                <div class="c-card-assistencia__icon-top">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2838_14018)">
                            <path d="M16.6654 8.33268C16.6654 12.4935 12.0495 16.8268 10.4995 18.1652C10.3551 18.2738 10.1794 18.3325 9.9987 18.3325C9.81803 18.3325 9.64226 18.2738 9.49786 18.1652C7.94786 16.8268 3.33203 12.4935 3.33203 8.33268C3.33203 6.56457 4.03441 4.86888 5.28465 3.61864C6.5349 2.36839 8.23059 1.66602 9.9987 1.66602C11.7668 1.66602 13.4625 2.36839 14.7127 3.61864C15.963 4.86888 16.6654 6.56457 16.6654 8.33268Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M10 10.834C11.3807 10.834 12.5 9.7147 12.5 8.33398C12.5 6.95327 11.3807 5.83398 10 5.83398C8.61929 5.83398 7.5 6.95327 7.5 8.33398C7.5 9.7147 8.61929 10.834 10 10.834Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_2838_14018">
                                <rect width="20" height="20" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>

                    <h3 class="c-card-assistencia__city">${item.cidade || ''}</h3>
                    <p class="c-card-assistencia__title">${item.titulo}</p>
                    ${item.logradouro ? `<p class="c-card-assistencia__text">${item.logradouro}${item.numero ? ', N°' + item.numero : ''}</p>` : ''}
                    ${item.bairro ? `<p class="c-card-assistencia__text">Bairro: ${item.bairro}</p>` : ''}
                    
                    <hr class="c-card-assistencia__divider">
                    
                    ${telefonesHTML}
                    ${emailsHTML}
                    
                    <a href="${mapsLink}" target="_blank" class="c-card-assistencia__link">Abrir no Google Maps</a>
                </article>
            `;
        }).join('');

        resultsContainer.innerHTML = cardsHTML;
    }

    /**
     * Constrói e injeta a paginação
     * @param {number} totalPaginas 
     */
    /**
 * Constrói e injeta a paginação
 * @param {number} totalPaginas 
 */
    function renderizarPaginacao(totalPaginas) {
        if (totalPaginas <= 1) return;

        let paginacaoHTML = '';

        // Botão Anterior (Só aparece se não estiver na primeira página)
        if (paginaAtual > 1) {
            paginacaoHTML += `<button type="button" class="c-pagination__button c-pagination__button--nav" data-page="${paginaAtual - 1}" aria-label="Página anterior">Anterior</button>`;
        }

        // Loop dos números das páginas
        for (let i = 1; i <= totalPaginas; i++) {
            const isAtiva = i === paginaAtual ? '--is-active' : '';
            paginacaoHTML += `<button type="button" class="c-pagination__button ${isAtiva}" data-page="${i}" aria-label="Ir para a página ${i}">${i}</button>`;
        }

        // Botão Próximo (Só aparece se não estiver na última página)
        if (paginaAtual < totalPaginas) {
            paginacaoHTML += `<button type="button" class="c-pagination__button c-pagination__button--nav" data-page="${paginaAtual + 1}" aria-label="Próxima página">Próximo</button>`;
        }

        paginationContainer.innerHTML = paginacaoHTML;
        paginationContainer.classList.remove('--is-hidden');

        // Refaz os Event Listeners para todos os botões (números e setas)
        const botoes = paginationContainer.querySelectorAll('.c-pagination__button');
        botoes.forEach(btn => {
            btn.addEventListener('click', (event) => {
                paginaAtual = parseInt(event.currentTarget.dataset.page, 10);
                buscarAssistencias();
            });
        });
    }
}